defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ClubSettings/Modals/RemovePlayerModal',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Avatar',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, PlayTogetherApi, Avatar, CtaButton) {
    var RemovePlayerModal = {
      controller: function ({ controller, player }) {
        Object.assign(this, controller);
        this.dictionary = this.rootDictionary.get.bind({ prefix: 'ClubSettings/RemovePlayerOverlay/' });

        this.processing = m.prop(false);
        this.player = player;
        this.playerId = this.player.playerId;

        this.confirm = () => {
          this.processing(true);
          PlayTogetherApi.removePlayer(this.clubId(), this.playerId).then(() => {
            if (!this.playerId || !this.isCurrentUserChairman()) {
              window.location.href = this.navigationPaths.myClubsPage;
              return;
            }

            this.clubModel().removePlayerFromClubPlayers(this.playerId);
            this.modal.close();
          }, (response) => {
            this.processing(false);
            this.error(response);
          });
        };
      },
      view: function (controller, { template, player }) {
        const currentUserIsSelf = player.playerId === controller.currentUserId();

        let heading = controller.dictionary('Title', { playerName: controller.player.name });
        let body = [
          m('.modal__player-row', [
            Avatar({
              name: controller.player.name
            }),
            controller.player.name
          ]),
          m.trust(controller.dictionary('Description', { playerName: controller.player.name }))
        ];
        let confirmButtonText = controller.dictionary('Confirm');

        if (currentUserIsSelf) {
          heading = controller.dictionary('TitleAsCurrentPlayer', { clubName: controller.clubName()() });
          body = m.trust(controller.dictionary('DescriptionAsCurrentPlayer', { clubName: controller.clubName()() }));
          confirmButtonText = controller.dictionary('RemoveYourselfButton');
        }

        const footer = [
          CtaButton({
            text: confirmButtonText,
            onClick: controller.confirm,
            loading: controller.processing()
          }),
          CtaButton({
            text: controller.dictionary('Dismiss'),
            className: 'yellow',
            onClick: () => controller.modal.close()
          })
        ];

        return template({ heading, body, footer });
      }
    };

    // Public functions:
    return RemovePlayerModal;
  });
